export default "__VITE_ASSET__CyS2GvNh__"